import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import type { TaskType } from "@/core/types";

import { ACPSatisfactionLoginTask } from "./ACPSatisfaction";
import { ConsentRouter } from "./ConsentRouter";
import { UploadPhotoIDLoginTask } from "./UploadPhotoID";

type LoginTasksProps = RouteComponentProps<{ task_name: TaskType }>;

export function LogInTasksRouter({ match }: LoginTasksProps) {
  const taskType = match.params.task_name;

  switch (taskType) {
    case "COMPLETE_ACP_SATISFACTION_SURVEY":
      return <ACPSatisfactionLoginTask />;

    case "ID_DOCUMENT_UPLOAD":
      return <UploadPhotoIDLoginTask />;

    case "UPDATED_CHILD_CONSENT":
    case "UPDATED_CONSENT_REQUIRED":
    case "UPDATED_POLICIES":
      return <ConsentRouter />;

    default:
      return null;
  }
}
